export const SN_MATRIXRATE = 'matrixrate'
export const MATRIXRATES_UPDATE_MATRIXRATE = SN_MATRIXRATE + '/UPDATE_MATRIXRATE'
export const MATRIXRATES_ADD_MATRIXRATE = SN_MATRIXRATE + '/ADD_MATRIXRATE'
export const MATRIXRATES_SET_CURRENT = SN_MATRIXRATE + '/SET_CURRENT'
export const MATRIXRATES_LOADING = SN_MATRIXRATE + '/LOADING'
